import React from 'react';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Box, Typography } from '@mui/material';
import { AuthPageStyles } from '../../../utilities/themeColors';
import { useTranslation } from 'react-i18next';
import useBrandingAssets from '../../../hooks/useBrandingAssets';

const PMDashboard = () => {
    const { t } = useTranslation();
    const { authBackdropStyle } = useBrandingAssets();

    return (
        <Box sx={{ p: 2, pt: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('TITLES.PREDICTIVE_MAINTENANCE_DASHBOARD')} />
            <Box sx={{
                ...(authBackdropStyle || AuthPageStyles), height: '100%',
                minHeight: '80vh',
                width: '100%',
                minWidth: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center', overflow: 'hidden'
            }}>

                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 2,
                        height: '100%',
                        width: '100%',
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h1" fontSize={"40px"} color="#fff" textAlign="center">
                        {t('UI_TEXT.COMING_SOON')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PMDashboard;
